import GetTopTenShopsDummyData from "../../../dummy/GetTopTenShopsDummyData.json";
import GetBookmarkedShopsDummyData from "../../../dummy/GetBookmarkedShopsDummyData.json";
import GetTopThreeSalesDummyData from "../../../dummy/GetTopThreeSalesDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import TopTenShopDto from "../dto/dashboard/TopTenShopDto";
import BookmarkedShopDto from "../dto/dashboard/BookmarkedShopDto";
import TopThreeSalesDto from "../dto/dashboard/TopThreeSalesDto";

class FakeDashboardApi {
    getTopTenShops = async (): Promise<SuccessResponse<TopTenShopDto[]>> => {
        return GetTopTenShopsDummyData;
    };

    getBookmarkedShops = async (): Promise<SuccessResponse<BookmarkedShopDto[]>> => {
        return GetBookmarkedShopsDummyData;
    };

    getTopThreeSales = async (): Promise<SuccessResponse<TopThreeSalesDto[]>> => {
        return GetTopThreeSalesDummyData;
    };
}

export default FakeDashboardApi;
